export default __webpack_public_path__ + "static/media/BohoHome.818cfc89.jpg";